import React, { useContext } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
// material
import { styled } from '@mui/material/styles';
import { Card, Typography, Alert } from '@mui/material';
// context
import { ReportContext } from '../../../contexts/Report';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(5, 0)
}));

const IconWrapperStyle = styled('div')(() => ({
  margin: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

// ----------------------------------------------------------------------

export default function AppTickets() {
  const { sales, isLoading, hasError } = useContext(ReportContext);

  if (hasError) {
    return (
      <Alert severity="error">
        An error occurred while trying to load the tickets — Please, try to refresh the page!
      </Alert>
    );
  }

  return (
    <RootStyle>
      {isLoading ? (
        <Typography align="center" variant="h3">
          <CircularProgress size={30} color="inherit" />
        </Typography>
      ) : (
        <IconWrapperStyle>
          <Typography variant="h2">{sales.paid.tickets.quantity}</Typography>
        </IconWrapperStyle>
      )}
      <Typography variant="subtitle2" sx={{ opacity: 1 }}>
        Tickets
      </Typography>
      {!isLoading && (
        <Typography variant="caption" color="text.secondary">
          Average {sales.paid.tickets.average.amount} €
        </Typography>
      )}
    </RootStyle>
  );
}
